export default {
    paginate: {
        next: 'Next',
        prev: 'Previous',
    },
}
